import React from 'react';
import { Link } from 'react-router-dom';
import './DealCard.css';

// Builds the deal page link, e.g. /deal/904/50-off-on-Womens-Striped-Bodycon-Maxi-Dress
export function dealLink(deal) {
  const slug = (deal.commondiscription || '')
    .replace(/[&/\\#,+()$~%.'":*?<>{}!]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return '/deal/' + deal.id + '/' + slug;
}

// Deals have no price fields yet, so the badge is read from the title text.
// "50% off ..." -> 50% OFF, "... FREE ..." -> FREE, "... $39+" -> $39+
export function dealBadge(title) {
  if (!title) return null;
  const pct = title.match(/(\d+)%\s*off/i);
  if (pct) return { text: pct[1] + '% OFF', kind: 'off' };
  if (/\bfree\b/i.test(title)) return { text: 'FREE', kind: 'free' };
  const price = title.match(/\$\d+(\.\d+)?\+?/);
  if (price) return { text: price[0], kind: 'price' };
  return null;
}

function DealCard({ deal }) {
  const link = dealLink(deal);
  const badge = dealBadge(deal.commondiscription);
  const store = deal.store && deal.store.store;

  return (
    <article className="deal-card">
      <Link to={link} className="deal-card-thumb">
        {badge && <span className={'deal-card-badge ' + badge.kind}>{badge.text}</span>}
        <img src={deal.imageurl} alt={deal.commondiscription} loading="lazy" />
      </Link>
      <div className="deal-card-body">
        {store && (
          <Link to={'/store/' + store} className="deal-card-store">{store}</Link>
        )}
        <Link to={link} className="deal-card-title">{deal.commondiscription}</Link>
        <Link to={link} className="deal-card-btn">Get Deal</Link>
      </div>
    </article>
  );
}

export default DealCard;
